import getAxiosInstance from '../../helpers/get_axios_instance'
import { OK } from 'http-status-codes'
import lrsAdapter from '../../helpers/lrs_adapter'

class CalleCalado {
  static CalleSugerida (claveCereal) {
    const axios = getAxiosInstance()
    const promise = axios.get(`calle_sugerida_por_cereal?r=` +
      `{"clave":{"cereal_asignado": "${claveCereal}"},` +
      `"limite":1, "orden": ["d:libre"]}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => {
        return result.data[0]
      })
  }

  static updateCerealCalleDeCalado (calle, cereal) {
    const axios = getAxiosInstance()
    const promise = axios.put(`calle_de_calado`,
      `{"valores": {"cereal_asignado": "${cereal}"},
    "clave":{"numero": "${calle}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static updateCalleDeCalado (numero, cereal, capacidad, habilitado) {
    const axios = getAxiosInstance()
    const promise = axios.put(`calle_de_calado`,
      `{"valores": {"cereal_asignado": "${cereal}", "capacidad": "${capacidad}", "habilitado": "${habilitado}"}, "clave":{"numero": "${numero}"}}`)
    return promise.then(lrsAdapter, lrsAdapter)
  }

  static getCallesDeCalado () {
    const axios = getAxiosInstance()
    const orden = '{"orden": ["numero"]}'
    const promise = axios.get(`calle_de_calado_listado?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data })
  }

  static getCallesCaladoPorCalle () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_calle_de_calado_por_calle_listado`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static getCallesCaladoPorCerealHumedad () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_calle_de_calado_por_cereal_humedad_listado`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static getConsultaEstadoOcupacionCallesCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_estado_ocupacion_calles_de_calado`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el estado de las Calles.')
      return data
    })
  }

  static getConsultaCalificacionPorCalleCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_calado_aceptado_calificacion_calle_listado`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static getCamionesCallesDeCaladoEgreso () {
    const orden = '{"orden": ["calle_de_calado"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`consulta_camiones_calle_de_calado_por_calle_listado?r=${orden}`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data })
  }

  static egresoCpaCalado (numero, calleDeBruto) {
    const axios = getAxiosInstance()
    const promise = axios.post(`carga_entrante_automotor_egreso_calado`,
      `{"valores": {"carta_de_porte_automotor": "${numero}", "calle_de_bruto": "${calleDeBruto}"}}`)
    return promise
  }

  static egresoCalleCalado (calle, cantidad) {
    const axios = getAxiosInstance()
    const promise = axios.post(`egreso_calle_calado`,
      `{"valores": {"calle": "${calle}", "cantidad":"${cantidad}"}}`)
    return promise
  }

  static anulacionEgresoCpaCalado (numero) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`carga_entrante_automotor_egreso_calado?r=` +
      `{"clave": {"carta_de_porte_automotor": "${numero}"}}`)
    return promise
  }

  static getProximoEgresoCalado () {
    const axios = getAxiosInstance()
    const promise = axios.get('proximo_egreso_calado')
    return promise.then(lrsAdapter, lrsAdapter)
      .catch(lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default CalleCalado
